'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _debug = require('./debug');

var _decorate = require('./decorate');

var _decorate2 = _interopRequireDefault(_decorate);

var _type = require('./type');

var _mergeArrayMap = require('./mergeArrayMap');

var _mergeArrayMap2 = _interopRequireDefault(_mergeArrayMap);

var _deprecate = require('./deprecate');

var _deprecate2 = _interopRequireDefault(_deprecate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isServer = typeof window === 'undefined';

exports.default = {
  debug: _debug.debug, isDebugMode: _debug.isDebugMode, decorate: _decorate2.default, is: _type.is, objectShapeChecker: _type.objectShapeChecker, mergeArrayMap: _mergeArrayMap2.default, mergeMapArrayMap: _mergeArrayMap.mergeMapArrayMap, deprecate: _deprecate2.default, isServer: isServer
};
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL21vZHVsZXMvdXRpbHMvaW5kZXguanMiXSwibmFtZXMiOlsiaXNTZXJ2ZXIiLCJ3aW5kb3ciLCJkZWJ1ZyIsImlzRGVidWdNb2RlIiwiZGVjb3JhdGUiLCJpcyIsIm9iamVjdFNoYXBlQ2hlY2tlciIsIm1lcmdlQXJyYXlNYXAiLCJtZXJnZU1hcEFycmF5TWFwIiwiZGVwcmVjYXRlIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQTs7QUFDQTs7OztBQUNBOztBQUNBOzs7O0FBQ0E7Ozs7OztBQUVBLElBQU1BLFdBQVcsT0FBT0MsTUFBUCxLQUFrQixXQUFuQzs7a0JBRWU7QUFDYkMscUJBRGEsRUFDTkMsK0JBRE0sRUFDT0MsNEJBRFAsRUFDaUJDLFlBRGpCLEVBQ3FCQyw0Q0FEckIsRUFDeUNDLHNDQUR6QyxFQUN3REMsaURBRHhELEVBQzBFQyw4QkFEMUUsRUFDcUZUO0FBRHJGLEMiLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBkZWJ1ZywgaXNEZWJ1Z01vZGUgfSBmcm9tICcuL2RlYnVnJ1xuaW1wb3J0IGRlY29yYXRlIGZyb20gJy4vZGVjb3JhdGUnXG5pbXBvcnQgeyBpcywgb2JqZWN0U2hhcGVDaGVja2VyIH0gZnJvbSAnLi90eXBlJ1xuaW1wb3J0IG1lcmdlQXJyYXlNYXAsIHsgbWVyZ2VNYXBBcnJheU1hcCB9IGZyb20gJy4vbWVyZ2VBcnJheU1hcCdcbmltcG9ydCBkZXByZWNhdGUgZnJvbSAnLi9kZXByZWNhdGUnXG5cbmNvbnN0IGlzU2VydmVyID0gdHlwZW9mIHdpbmRvdyA9PT0gJ3VuZGVmaW5lZCdcblxuZXhwb3J0IGRlZmF1bHQge1xuICBkZWJ1ZywgaXNEZWJ1Z01vZGUsIGRlY29yYXRlLCBpcywgb2JqZWN0U2hhcGVDaGVja2VyLCBtZXJnZUFycmF5TWFwLCBtZXJnZU1hcEFycmF5TWFwLCBkZXByZWNhdGUsIGlzU2VydmVyXG59XG4iXX0=